// DS: i1.14
import React, { useId } from 'react';
import IconWrap, { Props as IconWrapProps } from '../../IconWrap';

interface Props extends IconWrapProps {
  branded?: boolean;
}

const DreamUp: React.FC<Props> = ({ branded, ...rest }) => {
  const gradientAId = useId();
  const gradientBId = useId();
  const gradientCId = useId();
  const gradientDId = useId();
  return (
    <IconWrap {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        {branded ? (
          <>
            <path
              fill={`url(#${gradientAId})`}
              fillRule="evenodd"
              d="m15.86 6.58-.27.28-1.25 2.51-.39.28H9.5v3.84h2.45l.22.27-2.67 5.38v2.8h2.64l.27-.29 1.25-2.5.39-.29h4.45v-3.83h-2.45l-.22-.28 2.67-5.38V6.58z"
              clipRule="evenodd"
            ></path>
            <path
              fill={`url(#${gradientBId})`}
              fillRule="evenodd"
              d="M5.4 2a.05.05 0 0 0-.05.04c-.2 1.06-.79 1.73-1.9 1.91A.05.05 0 0 0 3.4 4a.04.04 0 0 0 0 .02c0 .02.02.04.04.04 1.12.18 1.7.85 1.91 1.9 0 .03.02.05.05.05s.04-.02.05-.04c.2-1.06.8-1.73 1.9-1.91.03 0 .04-.02.05-.04V4a.05.05 0 0 0-.04-.04c-1.12-.18-1.7-.85-1.91-1.9A.05.05 0 0 0 5.4 2"
              clipRule="evenodd"
            ></path>
            <path
              fill={`url(#${gradientCId})`}
              fillRule="evenodd"
              d="M6.5 7a.06.06 0 0 0-.06.05c-.26 1.33-1 2.16-2.39 2.4a.06.06 0 0 0-.05.04v.02c0 .03.03.05.05.05 1.4.23 2.13 1.06 2.4 2.39 0 .03.02.05.04.05h.01c.03 0 .05-.02.06-.05.26-1.33 1-2.16 2.39-2.4A.06.06 0 0 0 9 9.52V9.5a.06.06 0 0 0-.05-.05c-1.4-.23-2.13-1.06-2.4-2.39A.06.06 0 0 0 6.52 7z"
              clipRule="evenodd"
            ></path>
            <path
              fill={`url(#${gradientDId})`}
              fillRule="evenodd"
              d="M10.8 2.4a.07.07 0 0 0-.07.06c-.3 1.6-1.2 2.6-2.87 2.87a.07.07 0 0 0-.06.06v.02a.07.07 0 0 0 .06.06c1.68.28 2.56 1.28 2.87 2.87 0 .03.03.06.06.06h.01c.04 0 .07-.03.07-.06.3-1.59 1.2-2.6 2.87-2.87.03 0 .05-.02.06-.05v-.03a.07.07 0 0 0-.06-.06c-1.68-.28-2.56-1.28-2.87-2.87a.07.07 0 0 0-.06-.06z"
              clipRule="evenodd"
            ></path>
            <defs>
              <linearGradient
                id={gradientAId}
                x1="9.5"
                x2="18.9"
                y1="13.71"
                y2="9.73"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#C546A8"></stop>
                <stop offset="1" stopColor="#713CDE"></stop>
              </linearGradient>
              <linearGradient
                id={gradientBId}
                x1="3.4"
                x2="6.64"
                y1="3.86"
                y2="1.52"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#C546A8"></stop>
                <stop offset="1" stopColor="#713CDE"></stop>
              </linearGradient>
              <linearGradient
                id={gradientCId}
                x1="4"
                x2="8.05"
                y1="9.32"
                y2="6.4"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#C546A8"></stop>
                <stop offset="1" stopColor="#713CDE"></stop>
              </linearGradient>
              <linearGradient
                id={gradientDId}
                x1="7.8"
                x2="12.66"
                y1="5.19"
                y2="1.68"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#C546A8"></stop>
                <stop offset="1" stopColor="#713CDE"></stop>
              </linearGradient>
            </defs>
          </>
        ) : (
          <path
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
            d="m15.856 6.583-.264.281-1.247 2.51-.393.28H9.5v3.832h2.448l.218.278L9.5 19.14v2.79h2.644l.264-.28 1.247-2.51.392-.279H18.5V15.03h-2.448l-.218-.28L18.5 9.373v-2.79h-2.644ZM5.4 2h-.005a.047.047 0 0 0-.04.042C5.147 3.1 4.56 3.769 3.442 3.954a.046.046 0 0 0-.041.036l-.001.004v.001a.038.038 0 0 0 0 .011v.006a.05.05 0 0 0 .042.035c1.117.185 1.705.853 1.911 1.911.002.022.02.04.042.042A.04.04 0 0 0 5.4 6h.001a.047.047 0 0 0 .045-.042c.206-1.058.794-1.727 1.91-1.912A.046.046 0 0 0 7.4 4.01l.001-.004v-.001a.038.038 0 0 0 0-.006v-.006a.047.047 0 0 0-.042-.04C6.24 3.77 5.654 3.1 5.447 2.044A.046.046 0 0 0 5.405 2H5.4Zm1.1 5h-.007a.058.058 0 0 0-.05.052c-.259 1.324-.994 2.16-2.39 2.39a.058.058 0 0 0-.052.045v.007a.045.045 0 0 0 0 .01.04.04 0 0 0 0 .004v.007a.058.058 0 0 0 .053.043c1.395.231 2.13 1.067 2.388 2.39.003.027.024.05.052.052h.008a.058.058 0 0 0 .056-.052c.258-1.323.993-2.159 2.389-2.39A.058.058 0 0 0 9 9.508v-.002a.045.045 0 0 0 0-.007v-.008l-.002-.005a.058.058 0 0 0-.051-.044c-1.396-.231-2.13-1.066-2.389-2.39A.058.058 0 0 0 6.506 7h-.007Zm4.3-4.6h-.003l-.006.001a.07.07 0 0 0-.06.062c-.31 1.588-1.192 2.59-2.868 2.868a.07.07 0 0 0-.062.054v.009a.056.056 0 0 0-.001.008v.008a.07.07 0 0 0 .064.06c1.675.277 2.557 1.279 2.866 2.866a.07.07 0 0 0 .063.063.053.053 0 0 0 .008 0h.001a.07.07 0 0 0 .067-.062c.31-1.588 1.192-2.59 2.867-2.868a.07.07 0 0 0 .062-.054l.001-.007V5.39l-.001-.007a.07.07 0 0 0-.062-.052c-1.675-.278-2.556-1.28-2.867-2.867a.07.07 0 0 0-.062-.063h-.001a.534.534 0 0 1-.007 0Z"
          />
        )}
      </svg>
    </IconWrap>
  );
};
DreamUp.displayName = 'DreamUp';

export default DreamUp;
